import React from 'react';
import { Box, Typography, Container, IconButton, Divider } from '@mui/material';
import {
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  LinkedIn as LinkedInIcon,
  GitHub as GitHubIcon,
  Email as EmailIcon,
} from '@mui/icons-material';
import { wolvesLabsColors } from '../../theme/wolvesLabsTheme';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: <FacebookIcon />, url: 'https://facebook.com/wolveslabs', label: 'Facebook' },
    { icon: <TwitterIcon />, url: 'https://twitter.com/wolveslabs', label: 'Twitter' },
    { icon: <LinkedInIcon />, url: 'https://linkedin.com/company/wolveslabs', label: 'LinkedIn' },
    { icon: <GitHubIcon />, url: 'https://github.com/wolveslabs', label: 'GitHub' },
    { icon: <EmailIcon />, url: 'mailto:contacto@wolveslabs.com', label: 'Email' },
  ];

  return (
    <Box
      sx={{
        py: 6,
        backgroundColor: wolvesLabsColors.primary,
        color: 'white',
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center' }}>
          {/* Logo/Nombre */}
          <Typography
            variant="h4"
            sx={{
              fontWeight: 800,
              mb: 2,
              color: 'white !important',
              textShadow: '0 2px 10px rgba(255, 255, 255, 0.3)',
            }}
          >
            WolvesLabs
          </Typography>

          <Typography
            variant="body2"
            sx={{
              mb: 3,
              opacity: 0.8,
              maxWidth: '600px',
              mx: 'auto',
            }}
          >
            Transformando ideas en soluciones tecnológicas innovadoras
          </Typography>

          {/* Redes sociales */}
          <Box sx={{ mb: 4 }}>
            {socialLinks.map((social, index) => (
              <IconButton
                key={index}
                component="a"
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
                sx={{
                  color: 'white',
                  mx: 0.5,
                  '&:hover': {
                    color: wolvesLabsColors.tech,
                    transform: 'translateY(-3px)',
                  },
                  transition: 'all 0.3s ease',
                }}
              >
                {social.icon}
              </IconButton>
            ))}
          </Box>

          <Divider sx={{ my: 3, borderColor: 'rgba(255, 255, 255, 0.1)' }} />

          {/* Enlaces rápidos */}
          <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center', gap: 3, flexWrap: 'wrap' }}>
            {['Servicios', 'Sobre Nosotros', 'Contacto'].map((link, index) => (
              <Typography
                key={index}
                component="a"
                href={`#${link.toLowerCase().replace(' ', '-')}`}
                sx={{
                  color: 'white',
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                  opacity: 0.8,
                  '&:hover': {
                    opacity: 1,
                    color: wolvesLabsColors.tech,
                  },
                  transition: 'all 0.3s ease',
                }}
              >
                {link}
              </Typography>
            ))}
          </Box>

          {/* Copyright */}
          <Typography
            variant="body2"
            sx={{
              opacity: 0.6,
              fontSize: '0.85rem',
            }}
          >
            © {currentYear} WolvesLabs. Todos los derechos reservados.
          </Typography>

          <Typography
            variant="caption"
            sx={{
              display: 'block',
              mt: 1,
              opacity: 0.5,
              fontSize: '0.75rem',
            }}
          >
            Desarrollado con ❤️ por WolvesLabs
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;

